// extracted by mini-css-extract-plugin
module.exports = {"heading":"GameReview_heading__2WJO8","scollableNavBar":"GameReview_scollableNavBar__3MAO6"};